
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Component({})
export default class NotificationKey extends Vue {
    @Getter('notificationKey')
    readonly notificationKey!: string

    private status = 'not_found'

    @Action('loadNotificationKey')
    loadNotificationKey!: () => Promise<void>

    async created (): Promise<void> {
        await this.loadNotificationKey()

        this.status = this.notificationKey.length ? 'success' : 'not_found'
    }

    private copyLink () {
        if (this.status === 'success') {
            (this.$refs.notificationLinkContainer as Vue).$el.getElementsByTagName('input')[0].select()
            document.execCommand('copy')
        }
    }
}
